import { OneUxElementTheme } from '../../../common/OneUxElement'

export const OneUxTreeElementTheme: OneUxElementTheme<{}> = {
  light: {},
  dark: {}
}
